import { useQuery } from '@tanstack/react-query'
import {
  getTokenAnalyticsByModel,
  getTokenAnalyticsByUser,
  getTokenAnalyticsByWorkflow,
  type AnalyticsParams,
} from '@/api/analytics'
import { useTenantKey } from './useTenantKey'

const STALE_TIME = 5 * 60 * 1000

interface AnalyticsQueryOptions {
  enabled?: boolean
}

export function useTokenAnalyticsByWorkflow(
  projectId: string | undefined,
  params: AnalyticsParams,
  options?: AnalyticsQueryOptions
) {
  const tenantKey = useTenantKey()
  return useQuery({
    queryKey: tenantKey('analytics', 'token-usage', 'by-workflow', projectId, params),
    queryFn: () => getTokenAnalyticsByWorkflow(projectId!, params),
    staleTime: STALE_TIME,
    enabled: !!projectId && options?.enabled !== false,
  })
}

export function useTokenAnalyticsByUser(
  projectId: string | undefined,
  params: AnalyticsParams,
  options?: AnalyticsQueryOptions
) {
  const tenantKey = useTenantKey()
  return useQuery({
    queryKey: tenantKey('analytics', 'token-usage', 'by-user', projectId, params),
    queryFn: () => getTokenAnalyticsByUser(projectId!, params),
    staleTime: STALE_TIME,
    enabled: !!projectId && options?.enabled !== false,
  })
}

export function useTokenAnalyticsByModel(
  projectId: string | undefined,
  params: AnalyticsParams,
  options?: AnalyticsQueryOptions
) {
  const tenantKey = useTenantKey()
  return useQuery({
    queryKey: tenantKey('analytics', 'token-usage', 'by-model', projectId, params),
    queryFn: () => getTokenAnalyticsByModel(projectId!, params),
    staleTime: STALE_TIME,
    enabled: !!projectId && options?.enabled !== false,
  })
}
